module.exports = __webpack_public_path__ + "static/media/faq.dbd9bf14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guestlist/faq.svg
// module id = 1323
// module chunks = 53